export enum RoleEnum {
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_CONFIGURATOR_LOYALTY = 'ROLE_CONFIGURATOR_LOYALTY',
  ROLE_LOYALTY_ADMIN = 'ROLE_LOYALTY_ADMIN',
  ROLE_SERVICES_LOYALTY = 'ROLE_SERVICES_LOYALTY',
  ROLE_SUPPORT_LOYALTY = 'ROLE_SUPPORT_LOYALTY',
  ROLE_CRM_LOYALTY = 'ROLE_CRM_LOYALTY',
}
